import ClientProvider from "../../../modules/ClientProvider";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Dialog, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";

export const AdvisorPreferenceForm = ({ onClose }: { onClose: () => void }) => {
    const { getAccessTokenSilently } = useAuth0();
    const userHttpClient = ClientProvider.provideUserClient();
    const [ submitted, setSubmitted ] = useState(false);

    const handleSubmit = async (open: boolean) => {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await userHttpClient.updateSelf({ open_to_advising: open }, accessToken);
        if (error) {
            console.error(error);
        }
        if (data) {
            setSubmitted(true);
        }
    }

    const handleClose = () => {
        if (submitted) {
            onClose();
        }
    }

    return (
        <Dialog open={true} onClose={handleClose} sx={{ "& .MuiDialog-paper": { backgroundColor: "#ffffff" } }}>
            {submitted ?
                <>
                    <Typography variant="h5" fontWeight="bold">Welcome to the Summer Release</Typography>
                    <p>Thank you for your response! You can update your preferences at any time in your <Link to={`//app.${process.env.REACT_APP_APP_ORIGIN}/settings/preferences`}>settings</Link>.</p>
                    <Button onClick={handleClose}>Close</Button>
                </>
            :
                <>
                    <Typography variant="h5" fontWeight="bold">Welcome to the Summer Release</Typography>
                    <p>As part of our Summer Release, we're excited to offer you the opportunity to advise on new companies in your wheelhouse.</p>
                    <p><strong>Are you interested in additional advisory roles?</strong></p>
                    <Stack direction="row" spacing="20px" width="100%">
                        <Button variant="contained" onClick={() => handleSubmit(true)} sx={{ flex: 1 }}>Yes, I'm interested</Button>
                        <Button variant="outlined" onClick={() => handleSubmit(false)} sx={{ flex: 1 }}>No, not at this time</Button>
                    </Stack>
                </>
            }
        </Dialog>
    );
}